import { gql } from "@apollo/client";

export const saveEnrollment = gql`
  mutation saveEnrollment(
    $application: ApplicationInput!
    $company_id: String!
    $recaptcha_token: String
  ) {
    saveEnrollment(
      application: $application
      company_id: $company_id
      recaptcha_token: $recaptcha_token
    )
  }
`;

export const userVerifySSN = gql`
  mutation userVerifySSN($application_id: String!, $ssn: String!) {
    userVerifySSN(application_id: $application_id, ssn: $ssn)
  }
`;

export const saveTradelines = gql`
  mutation saveTradelines($tradelines: [String]!, $application_id: String!) {
    saveTradelines(tradelines: $tradelines, application_id: $application_id)
  }
`;

export const selectPlan = gql`
  mutation selectPlan($plan_id: String!, $application_id: String!) {
    selectPlan(plan_id: $plan_id, application_id: $application_id) {
      id
    }
  }
`;

export const seStartDate = gql`
  mutation seStartDate(
    $application_id: String!
    $start_date: String!
    $company_id: String!
  ) {
    seStartDate(
      application_id: $application_id
      start_date: $start_date
      company_id: $company_id
    )
  }
`;

export const saveManualAccount = gql`
  mutation saveManualAccount(
    $application_id: String!
    $name: String!
    $logo: String
    $url: String
    $account_number: String!
    $routing_number: String!
    $account_type: String!
  ) {
    saveManualAccount(
      application_id: $application_id
      name: $name
      logo: $logo
      url: $url
      account_number: $account_number
      routing_number: $routing_number
      account_type: $account_type
    )
  }
`;

export const saveCreditCard = gql`
  mutation saveCreditCard(
    $application_id: String!
    $issuer: String
    $ccName: String!
    $ccNumber: String!
    $ccExp: String!
    $ccCvc: String!
  ) {
    saveCreditCard(
      application_id: $application_id
      issuer: $issuer
      ccName: $ccName
      ccNumber: $ccNumber
      ccExp: $ccExp
      ccCvc: $ccCvc
    )
  }
`;

export const createSubscription = gql`
  mutation createSubscription(
    $application_id: String!
    $pdf_content: String!
    $from_apply: Boolean
  ) {
    createSubscription(
      application_id: $application_id
      pdf_content: $pdf_content
      from_apply: $from_apply
    )
  }
`;

export const trackUniqueVisitor = gql`
  mutation trackUniqueVisitor(
    $self_enrollment_id: String!
    $user_agent: String!
    $device_fingerprint: String
    $device_type: String!
    $browser: String
    $os: String
    $screen_resolution: String
    $source: String
    $medium: String
    $campaign: String
    $referrer: String
    $landing_page: String
    $session_id: String
    $country: String
    $region: String
    $city: String
  ) {
    trackUniqueVisitor(
      self_enrollment_id: $self_enrollment_id
      user_agent: $user_agent
      device_fingerprint: $device_fingerprint
      device_type: $device_type
      browser: $browser
      os: $os
      screen_resolution: $screen_resolution
      source: $source
      medium: $medium
      campaign: $campaign
      referrer: $referrer
      landing_page: $landing_page
      session_id: $session_id
      country: $country
      region: $region
      city: $city
    )
  }
`;

// Phone Verification for Self Enrollment
export const seSendPhoneVerification = gql`
  mutation seSendPhoneVerification(
    $application_id: String!
    $phone: String!
    $recaptcha_token: String
  ) {
    seSendPhoneVerification(
      application_id: $application_id
      phone: $phone
      recaptcha_token: $recaptcha_token
    ) {
      success
      masked_destination
      error
    }
  }
`;

export const seVerifyPhoneCode = gql`
  mutation seVerifyPhoneCode(
    $application_id: String!
    $phone: String!
    $code: String!
  ) {
    seVerifyPhoneCode(
      application_id: $application_id
      phone: $phone
      code: $code
    ) {
      success
      error
    }
  }
`;

export const updateSelfEnrollmentStat = gql`
  mutation updateSelfEnrollmentStat(
    $application_id: String
    $self_enrollment_id: String!
    $page: String!
    $drop_off_page: String
    $reached_dead_end: Boolean
    $visitor_id: String
    $device_type: String
    $browser: String
    $os: String
    $source: String
    $medium: String
    $campaign: String
    $referrer: String
    $session_id: String
    $time_spent_on_page: Int
    $is_completion: Boolean
    $link_visitor_to_application: Boolean
  ) {
    updateSelfEnrollmentStat(
      application_id: $application_id
      self_enrollment_id: $self_enrollment_id
      page: $page
      drop_off_page: $drop_off_page
      reached_dead_end: $reached_dead_end
      visitor_id: $visitor_id
      device_type: $device_type
      browser: $browser
      os: $os
      source: $source
      medium: $medium
      campaign: $campaign
      referrer: $referrer
      session_id: $session_id
      time_spent_on_page: $time_spent_on_page
      is_completion: $is_completion
      link_visitor_to_application: $link_visitor_to_application
    )
  }
`;
